function chmButton(button) {
    var $button;
    $button = $('<div>').addClass('button').attr('tabindex', 0);

    if (button.tertiary) {
        $button.attr('data-button-type', 'tertiary');
    }

    if (button.secondary) {
        $button.attr('data-button-type', 'secondary');
    }

    if (button.primary) {
        $button.attr('data-button-type', 'primary');
    }

    if (button.label) {
        $button.append($('<span>').addClass('button-label').append(button.label));
    }

    if (button.icon) {
        $button[button.iconRight ? 'append' : 'prepend']($('<span>').addClass('button-icon').append(button.icon));
    }

    $button.on('click', function() {
        ScoreTrekBattle.Event.callFunction(button.action);
    }).on('keydown', function(event) {
        if ((event.which === 13) || (event.which === 32)) {
            event.stopPropagation();
            event.preventDefault();
            $button.trigger('click');
        }
    });

    return $button;
}
